// extracted by mini-css-extract-plugin
export default {"description":"macroeconomic_description__rSw0l","content":"macroeconomic_content__sR+bY"};